export const useGoToNextStep = (delayInMilliseconds, goToNextStep) => () =>
  setTimeout(() => {
    goToNextStep();
  }, delayInMilliseconds);
